'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { Map as ImmutableMap } from 'immutable';
import { map } from 'rxjs/operators/map';
import { ContentTypes } from '../constants/base';
import MAB from '../models/MAB';
import MABEndTest from '../models/MABEndTest';
import MABPastExperiments from '../models/MABPastExperiments';
const PAGES_BASE_PATH = 'cospages/v2';
const URL = ImmutableMap({
  [ContentTypes.LANDING_PAGE]: `${PAGES_BASE_PATH}/landing-pages`,
  [ContentTypes.SITE_PAGE]: `${PAGES_BASE_PATH}/site-pages`
});
export default {
  endExperiment(mabExperimentId, contentType, winnerId) {
    return http.post(`${URL.get(contentType)}/mab-end-experiment/${mabExperimentId}`, {
      data: {
        winnerId
      }
    }).pipe(map(MABEndTest.fromJS));
  },

  fetch(mabExperimentId, contentType) {
    return http.get(`${URL.get(contentType)}/mab-get-experiment/${mabExperimentId}`).pipe(map(MAB.fromJS));
  },

  fetchPastExperiments(contentId, contentType) {
    return http.get(`${URL.get(contentType)}/${contentId}/mab-get-past-experiments`).pipe(map(MABPastExperiments.fromJS));
  }

};